module.exports = __webpack_public_path__ + "03_long_grey.78420879.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/03_long_grey.png
// module id = 9p7C
// module chunks = 0